class FindDoctor extends HTMLElement {
  constructor() {
    super();
    this.resultBlock = null;
    this.resultBlockGeneral = null;
    this.checkedResultBlock = null;
    this.searchInput = null;
    this.editButton = null;
    this.hitsData = null;
    this.searchClient = algoliasearch.algoliasearch('P0Z7SW5ST1', '6ae1c924d6fbc5a4087e7310781f29b1');

    this.initMutationObserver();
  }

  connectedCallback() {
    if (window.theme.doctor_recommended_info) {
      this.getDoctorByObjectID();
    }
    this.cacheDOMElements();
    this.hideAllResults();
    this.loadDoctorFromLocalStorage();
    this.attachEventListeners();
  }

  initMutationObserver() {
    this.observer = new MutationObserver(() => {
      const form = document.querySelector('.cart__form');
      if (form) {
        this.attributesDoctorDataInput = form.querySelector('.attributes--doctor-data');
        if (this.attributesDoctorDataInput) {
          this.loadDoctorFromLocalStorage();
          this.observer.disconnect();
        }
      }
    });
    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  cacheDOMElements() {
    this.resultBlock = this.querySelector('.find-doctor__result');
    this.resultBlockGeneral = this.querySelector('.find-doctor__result-block');
    this.checkedResultBlock = this.querySelector('.find-doctor__result-checked');
    this.searchInput = this.querySelector('.find-doctor__input');
    this.editButton = this.querySelector('.find-doctor__result-checked-edit');
  }

  hideAllResults() {
    [this.resultBlock, this.checkedResultBlock].forEach(el => el.style.display = 'none');
  }

  showElement(element) {
    element.style.display = 'block';
  }

  renderResults(hits) {
    this.resultBlock.innerHTML = hits.length
      ? `<ul>${hits.map(this.createResultItem.bind(this)).join('')}</ul>`
      : '<p class="find-doctor__error">No doctors found.</p>';
    this.showElement(this.resultBlock);
  }

  createResultItem(hit) {
    const { name, parent, address, objectID, indexName } = hit;
    const addressParts = [parent, address?.city, address?.line_1, address?.region, address?.postalCode, address?.country].filter(Boolean);
    const badgeClass = indexName === 'PROD_PRN_DOC' ? 'find-doctor__badge-doc' : 'find-doctor__badge-hos';

    return `
      <li class="find-doctor__result-item" data-id="${objectID}" data-index="${indexName}">
        <span class="${badgeClass}">${indexName === 'PROD_PRN_DOC' ? 'Doctor' : 'Hospital'}</span>
        <p class="find-doctor__result-item-name">${name.replace(`${parent} :`, '').trim()}</p>
        <p class="find-doctor__result-item-address">${addressParts.join(', ') || 'Address not available'}</p>
        <p class="find-doctor__result-item-add">Add</p>
      </li>`;
      
  }

  updateSelectedDoctor({ name, address, id, indexName, objectData }) {
    this.querySelector('.find-doctor__result-checked-name').textContent = name;
    this.querySelector('.find-doctor__result-checked-address').textContent = address;
  
    const badgeElement = this.querySelector('.find-doctor__result-checked-badge');
    if (badgeElement) {
      badgeElement.textContent = indexName === 'PROD_PRN_DOC' ? 'Doctor' : 'Hospital';
      badgeElement.className = `find-doctor__result-checked-badge ${indexName === 'PROD_PRN_DOC' ? 'find-doctor__badge-doc' : 'find-doctor__badge-hos'}`;
    }
  
    this.hideAllResults();
    this.showElement(this.checkedResultBlock);
  
    if (this.attributesDoctorDataInput) {
      this.attributesDoctorDataInput.value = objectData ? JSON.stringify(objectData) : ''; 
    }
  
    if (!window.location.pathname.includes('/cart')) {
      this.classList.add('find-doctor--checked');
      document.querySelector('.subtotal-label-block label')?.style.setProperty('display', 'none');
    }
  }

  loadDoctorFromLocalStorage() {
    const storedDoctor = localStorage.getItem('selectedDoctor');
    if (storedDoctor) {
      this.updateSelectedDoctor(JSON.parse(storedDoctor));
      this.searchInput.parentElement.style.display = 'none';
    }
  }

  attachEventListeners() {
    this.searchInput.addEventListener('input', e => {
      const query = e.target.value.trim();
      if (query.length >= 2) {
        this.performSearch(query);
      } else {
        this.hideAllResults();
      }
    });

    this.searchInput.addEventListener('focus', e => {
      const query = e.target.value.trim();
      if (query.length >= 2) {
        this.performSearch(query);
      }
    });
    const isVisited = localStorage.getItem('visitDoctorRecommendationPage') === 'true';

    if (isVisited || this.getDoctorByMetafield) {
      this.editButton.style.display = 'none'
    }

    this.editButton.addEventListener('click', () => {
      localStorage.removeItem('selectedDoctor');
      if (this.attributesDoctorDataInput.value) {
        this.attributesDoctorDataInput.value = '';
      }
    
      this.hideAllResults();
      this.showElement(this.resultBlockGeneral);
      this.searchInput.parentElement.style.display = 'block';
      this.searchInput.focus();
      this.classList.remove('find-doctor--checked');
      document.querySelector('.subtotal-label-block label')?.style.removeProperty('display');
    
      this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    this.resultBlock.addEventListener('click', e => {
      const item = e.target.closest('.find-doctor__result-item');
      if (!item) return;
    
      const selectedItemId = item.dataset.id;
      const selectedDoctor = this.hitsData.find(hit => hit.objectID === selectedItemId);
    
      if (selectedDoctor) {
        
        const { _highlightResult, ...doctorWithoutHighlightResult } = selectedDoctor;

        this.searchInput.parentElement.style.display = 'none';
        this.updateSelectedDoctor({
          name: item.querySelector('.find-doctor__result-item-name').textContent,
          address: item.querySelector('.find-doctor__result-item-address').textContent,
          id: doctorWithoutHighlightResult.objectID,
          indexName: doctorWithoutHighlightResult.indexName,
          objectData: doctorWithoutHighlightResult,
        });
    
        localStorage.setItem('selectedDoctor', JSON.stringify({
          name: item.querySelector('.find-doctor__result-item-name').textContent,
          address: item.querySelector('.find-doctor__result-item-address').textContent,
          id: doctorWithoutHighlightResult.objectID,
          indexName: doctorWithoutHighlightResult.indexName,
          objectData: doctorWithoutHighlightResult,
        }));
      }
    });

    document.addEventListener('click', e => {
      if (!this.contains(e.target)) this.resultBlock.style.display = 'none';
    });
  }

  async getDoctorByObjectID(query = '') {
    try {
      const { results } = await this.searchClient.search([
        {
          indexName: 'PROD_PRN_DOC',
          filters: `objectID:${window.theme.doctor_recommended_info}`,
          query
        },
        { 
          indexName: 'PROD_PRN_HOS',
          filters: `objectID:${window.theme.doctor_recommended_info}`,
          query
        }
      ]);

      if (!results?.length || !results[0]?.hits?.length) {
        console.log('No doctor found.');
        return;
      }
      const doctorData = results[0].hits[0];
      const { _highlightResult, ...doctorWithoutHighlightResult } = doctorData;
      const addressParts = [doctorData.parent, doctorData.address?.city, doctorData.address?.line_1, doctorData.address?.region, doctorData.address?.postalCode, doctorData.address?.country].filter(Boolean);
      const addressString = addressParts.join(', ');

      localStorage.setItem('selectedDoctor', JSON.stringify({
        name: doctorData.name.split(':')[1].trim(),
        address: addressString,
        id: doctorData.objectID,
        indexName: 'PROD_PRN_DOC',
        objectData: doctorWithoutHighlightResult,
      }));
      this.getDoctorByMetafield = true
    } catch (err) {
      console.error('Error fetching doctor:', err);
    }
  }

  async performSearch(query = '') {
    try {
      const { results } = await this.searchClient.search([ 
        { 
          indexName: 'PROD_PRN_DOC', 
          query,
          hitsPerPage: 50
        },
        { 
          indexName: 'PROD_PRN_HOS', 
          query,
          hitsPerPage: 50
        }
      ]);

        let hits = [
            ...results[0].hits.map(hit => ({ ...hit, indexName: 'PROD_PRN_DOC' })),
            ...results[1].hits.map(hit => ({ ...hit, indexName: 'PROD_PRN_HOS' }))
        ];

        hits.sort((a, b) => {
            const aMatches = this.getMatchCount(a.name, query);
            const bMatches = this.getMatchCount(b.name, query);
            return bMatches - aMatches;
        });
        this.hitsData = hits;
        this.renderResults(hits);
    } catch (err) {
        console.error('Error:', err);
    }
  }

  getMatchCount(text, query) {
    const regex = new RegExp(query, 'gi');
    const matches = text.match(regex);
    return matches ? matches.length : 0;
  }
}

customElements.define('find-doctor', FindDoctor);
